// Gross hack because the active links are somehow broken in the drawer
import $ from "jquery";

function clearActiveClass() {
  $(".pure-drawer .section.active").removeClass("active");
}

function resetActiveClass() {
  clearActiveClass();
  if (location.hash) {
    $(`.pure-drawer a[href='${location.hash}']`).parent().addClass("active");
  } else {
    $(".pure-drawer .section").first().addClass("active");
  }
}

function activateLink(e) {
  clearActiveClass();
  $(e.target.closest("li")).addClass("active");
}

function toggleHamburgerText(e) {
  if ($(e.target).hasClass("open")) {
    $(e.target).removeClass("open");
  } else {
    $(e.target).addClass("open");
  }
}

$(document).on("turbolinks:load", () => {
  resetActiveClass();
  $(".pure-drawer .section").on("click", activateLink);
  $(".pure-drawer #main-nav-hamburger").on("click", toggleHamburgerText);
});
